import React from 'react';
import Calendar from '../components/Calendar'; // Import the Calendar component

const CalendarPage = () => {
  return (
    <div>
      <h1>Calendar Page</h1>
      <Calendar /> {/* Use the Calendar component here */}
    </div>
  );
};

export default CalendarPage;